// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup, { NavGroupProps } from './NavGroup';
import menuItem from 'menu-items';
import { useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { NavItemType } from 'types';
import menuItems from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    let claims = useSelector(getUserClaims);
    if (claims && hasClaimsFor(menuItem, claims)) {
        const navItems = menuItem.items.filter(x => hasClaim(x, claims)).map((item) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });

        return <>{navItems}</>;
    }
    return <></>
};

export default MenuList;
export function hasClaimsFor(menuItem: { items: NavItemType[]; }, claims: any) {
    let items = getItemsWithCompatableClaims(menuItems.items, claims);
    return items.length;
}

function getItemsWithCompatableClaims(items: NavItemType[], claims: any) {
    let compatible_items: any[] = [];
    items.filter(x => {
        if (x.claim && claims && claims[toJavascriptName(x.claim)] && x.type === 'item') {
            compatible_items.push(x);
        }
        else if (!x.claim && x.type === 'item') {
            compatible_items.push(x);
        }
        else if (x.type === 'collapse' && x.claim && claims[toJavascriptName(x.claim)]) {
            compatible_items.push(...childrenWithCompatibleClaims(x as NavGroupProps, claims))
        }
        else if (x.type === 'collapse' && !x.claim) {
            compatible_items.push(...childrenWithCompatibleClaims(x as NavGroupProps, claims))
        }
        else if (x.type === 'group') {
            compatible_items.push(...childrenWithCompatibleClaims(x as NavGroupProps, claims))
        }
    })
    return compatible_items;
}

export function hasClaim(item: any, claims: any) {
    return childrenWithCompatibleClaims(item, claims).length;
}
function childrenWithCompatibleClaims(arg0: any, claims: any) {
    let result: any[] = [];

    switch (arg0?.item?.type) {
        case 'collapse':
            result.push(...getItemsWithCompatableClaims(arg0.item.children, claims))
            break;
        case 'item':
            result.push(...getItemsWithCompatableClaims([arg0.item], claims))
            break;
        case 'group':
            result.push(...getItemsWithCompatableClaims((arg0 as any).children, claims))
            break;
        default:
            switch (arg0?.type) {
                case 'group':
                    result.push(...getItemsWithCompatableClaims((arg0 as any).children, claims))
                    break;
                case 'collapse':
                    result.push(...getItemsWithCompatableClaims(arg0.children, claims))
                    break;
                case 'item':
                    if (arg0.claim && claims && claims[toJavascriptName(arg0.claim)] && arg0.type === 'item') {
                        result.push(arg0);
                    }
                    else if (!arg0.claim && arg0.type === 'item') {
                        result.push(arg0);
                    }
                    break;
            }
            break;
    }


    return result;
}

function toJavascriptName(str: string) {
    if (str) {
        str = str.trim();
    }
    if (str && str[0]) {
        str = str.split(' ').join('').split('-').join('');
        try {
            return str[0].toLowerCase() + str.substr(1);
        } catch (e) {
            console.log(str);
            console.log(str.length);
        }
    }
    return str;
};